module.exports = __webpack_public_path__ + "static/media/logo-accent.b18848f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo-accent.svg
// module id = 786
// module chunks = 0